const handleModal = () => {
  const selectors = {
    modal: '.js-modal',
    html: 'html',
    header: '.l-header',
    openBtn: '.js-modal-open-trigger',
    closeBtn: '.js-modal-close-trigger',
    animElems: '[data-scroll]',
  };

  const classes = {
    active: 'is-active',
    overflow: 'ui-overflow',
    inView: 'is-inview',
    headerHidden: 'l-header--scrolled',
  };

  const modals = [...document.querySelectorAll(selectors.modal)];

  if (modals.length === 0) return;

  const openBtns = document.querySelectorAll(selectors.openBtn);
  const html = document.querySelector(selectors.html);
  const header = document.querySelector(selectors.header);

  const toggleBodyOverflow = (force = null) => {
    html.classList.toggle(classes.overflow, force);
  };

  const closeModal = ({ modal }) => {
    modal?.classList.remove(classes.active);
    toggleBodyOverflow(false);

    const animElems = modal.querySelectorAll(selectors.animElems);
    animElems.forEach((elem) => elem.classList.remove(classes.inView));
  };

  const openModal = ({ modal }) => {
    const animElems = modal.querySelectorAll(selectors.animElems);

    modal?.classList.add(classes.active);
    toggleBodyOverflow(true);

    setTimeout(() => {
      header?.classList.add(classes.headerHidden);
    }, 500);

    animElems.forEach((elem, index) => {
      setTimeout(() => {
        elem.classList.add(classes.inView);
      }, index * 30);
    });
  };

  const handleOpenModalBtnClick = ({ e }) => {
    const { modalId } = e.currentTarget.dataset;
    const modalToOpen = modals.find(
      (modal) => modal.dataset.modalId === modalId
    );

    openModal({ modal: modalToOpen });
  };

  const addClickListener = ({ btn, callback, ...rest }) => {
    btn.addEventListener('click', (e) => callback({ e, ...rest }));
  };

  const initModal = (modal) => {
    const closeBtns = modal.querySelectorAll(selectors.closeBtn);

    if (closeBtns.length == 0) return;

    closeBtns.forEach((btn) =>
      addClickListener({ btn, modal, callback: closeModal })
    );
  };

  openBtns.forEach((btn) =>
    addClickListener({ btn, callback: handleOpenModalBtnClick })
  );
  modals.forEach(initModal);
};

export default handleModal;
